import { render } from "./LayersPanelLayer.vue?vue&type=template&id=c6f08814&scoped=true&ts=true"
import script from "./LayersPanelLayer.vue?vue&type=script&lang=ts"
export * from "./LayersPanelLayer.vue?vue&type=script&lang=ts"

import "./LayersPanelLayer.vue?vue&type=style&index=0&id=c6f08814&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f08814"]])

export default __exports__